import React from 'react'
import {ModalBase} from '../ModalBase'
import './modal-error.css'
import IconError from '../../../media/felsv/WarningError.svg'
import IconAlert from '../../../media/felsv/AlertError.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {generalCloseModalError} from '../../../actions/general.actions'
import { REGEX_HTML } from '../../../constants/Regex'

const ModalError = () => {
  const {message, tipo} = useSelector((state: State) => state.general.modalError)
  const dispatch = useDispatch()

  const htmlToJSX = (texto: string) => {
    if (texto && REGEX_HTML.test(texto)) return <div dangerouslySetInnerHTML={{__html: texto}}></div>    
    return texto
  }

  const close = () => dispatch(generalCloseModalError())

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '550px', backgroundColor: '#f1f1f1'}}>
      <div className='modal-error-buttons-fixed-top'>
        {tipo === 400 ? (
          <div className='w-layout-hflex '>
            <h3 className='modal-alert-title'>
              <img src={IconAlert} alt='error' />
              <span>&nbsp;Alerta</span>
            </h3>
          </div>
        ) : (
          <div className='w-layout-hflex '>
            <h3 className='modal-error-title'>
              <img src={IconError} alt='error' />
              <span>&nbsp;Error</span>
            </h3>
          </div>
        )}
        <div className='form-separator'></div>
      </div>
      <div className='modal-error-content'>
        <div className='modal-error-message'>{htmlToJSX(message)}</div>
      </div>
      <div className='modal-error-buttons-fixed-bottom'>
        <div className='w-layout-hflex button-actions'>
          <button autoFocus className='m button error w-inline-block' onClick={close}>
            Aceptar
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalError
